import { SiteDto } from '@app/generated/model';

export class Site {
  id: string;
  name: string;
  selected?: boolean;

  static fromDto(dto: SiteDto): Site {
    return {
      id: dto.id,
      name: dto.name,
      selected: dto.selected,
    };
  }
}
